import { useSphere } from '@react-three/cannon'
import React, { useRef, useEffect, useMemo, useState } from 'react'
import * as THREE from 'three'
import { useThree, useFrame } from '@react-three/fiber'
import usePlayerControls from './usePlayerControls'



const SPEED = 25;
const direction = new THREE.Vector3()
// const lookAt = new THREE.Vector3(0, 0, 1000)
const frontVector = new THREE.Vector3()
const sideVector = new THREE.Vector3()


const Player = ({activeSpace, activeSpaceId}) => {

    const [ref, api] = useSphere(() => ({ 
        mass: 100, 
        type: "Dynamic",   
        position : [0, 0, 0], 
        rotation: [0, 0, 0],
        args : [8]
    }))
    
    const {forward, backward, left, right} = usePlayerControls()



    useEffect(() => {
        api.position.set(0, 0, 0)
    }, [activeSpaceId])

    const playerRef = useRef()

    const { camera, viewport } = useThree()
    
    const {initialLookAt, vec} = useMemo(() =>{
        return {
            initialLookAt :  new THREE.Vector2(camera.position.x, camera.position.z),
            vec : new THREE.Vector3()
        }
    }, [])
    
    const velocity = useRef([0, 0, 0])

    useEffect(() => {
        api.position.set(0, 0, 0)
    },[activeSpace])

    useEffect(() => void api.velocity.subscribe((v) => (velocity.current = v)), [])

    useFrame(() => {
            ref.current.getWorldPosition(playerRef.current.position);
            playerRef.current.position.y = 0.5
            
            frontVector.set(0, 0, Number(backward) - Number(forward))
            sideVector.set(Number(left)-Number(right), 0, 0)
            direction.subVectors(frontVector, sideVector).normalize().multiplyScalar(SPEED)
            api.velocity.set(direction.x, -3, direction.z)
    })

    return (
        <>
            <mesh ref={ref} >
                <sphereBufferGeometry args={[8]}/>
                <meshBasicMaterial color={'yellow'} visible={false} />
            </mesh>
            <group ref={playerRef} position={[0,0,0]} >
                <mesh position={[0, 0, 1.5]} rotation={[-Math.PI/2, 0, 0]}>
                    <planeBufferGeometry args={[9, 9]} />
                    <meshBasicMaterial color={'black'} transparent opacity={0.99} side={THREE.DoubleSide} />
                </mesh>
            </group>
        </>
    )
}

export default Player
